import React, { Component } from 'react';
import { Col } from 'react-materialize';
import { Table, Input } from 'semantic-ui-react';
import { HOSTNAME } from '../config.js';
import '../css/types.css';

export class Calculator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      length: 0,
      formatedDetails: []
    }
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData() {
    let that = this;
    fetch(HOSTNAME + '/api.php/detail?transform=1')
    .then(response => response.json())
    .then(parsedJson => parsedJson.detail.map(detail => (
      {
        id: `${detail.detail_id}`,
        name: `${detail.detail_name}`
      }
    )))
    .then(detail => this.setState({detail}))
    .catch(error => console.log('fetch detail error:', error));

    fetch(HOSTNAME + '/api.php/details?transform=1')
      .then(response => response.json())
      .then(function(parsedJson) {
        let currentDetails = parsedJson.details;
        let array = [];
        for (let i = 0; i < currentDetails.length; i++) {
          if (parseInt(that.props.id, 10) === currentDetails[i].barrier_id) {
            array.push(
              {
                detailId: currentDetails[i].detail_id,
                formula: currentDetails[i].formula
              }
            );
          }
        }
        currentDetails = array;
        that.setState({currentDetails: currentDetails});
      })
  }

  changeLength(field, length) {
    this.setState({length: length.value});
  }

  render() {
    let currentDetails = this.state.currentDetails;
    let detail = this.state.detail;
    let formatedDetails = [];
    let tableRow = [];

    if (this.state.currentDetails) {
      for (let i = 0; i < currentDetails.length; i++) {
        for (let j = 0; j < detail.length; j++) {
          if (parseInt(currentDetails[i].detailId, 10) === parseInt(detail[j].id, 10)) {
            formatedDetails.push({
              detailName: detail[j].name,
              formula: currentDetails[i].formula
            })
          }
        }
      }

      for (let i = 0; i < formatedDetails.length; i++) {
        let L = this.state.length;
        let formula;

        try {
          formula = eval(String(formatedDetails[i].formula.replace("L", L)));
        } catch (e) {
          formula = '-';
        }

        tableRow.push(
          <Table.Row key={i}>
            <Table.Cell>{formatedDetails[i].detailName}</Table.Cell>
            <Table.Cell>{formula}</Table.Cell>
          </Table.Row>
        );
      }
    }

    return(
      <div className="calculator">
        <Col s={12} m={12}>
          <label>Введите длину: </label>
          <Input
            onChange={this.changeLength.bind(this)}
            value={this.state.length}
            placeholder="Введите длину"
            type="number"
          />
        </Col>
        <Col s={4} m={4}>
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Наименование детали</Table.HeaderCell>
                <Table.HeaderCell>Количество элементов в комплекте</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {tableRow}
            </Table.Body>
          </Table>
        </Col>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/calculator.js